// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"InputLabel_inputWrapper__30yH3","passwordIcon":"InputLabel_passwordIcon__3Yz6e","error":"InputLabel_error__3yq6t"};